import request from '@/utils/request'

/**
 * 技师排班相关API
 */
let ScheduleApi = {
  /**
   * 获取技师排班列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getList(data, errorback) {
    return request._post('/supplier/technician.schedule/index', data, errorback);
  },

  /**
   * 获取技师信息和排班列表
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  technicianList(data, errorback) {
    return request._post('/supplier/technician.schedule/technicianList', data, errorback);
  },
  /**
   * 添加技师排班
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  add(data, errorback) {
    return request._post('/supplier/technician.schedule/add', data, errorback);
  },
  /**
   * 修改技师排班
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  edit(data, errorback) {
    return request._post('/supplier/technician.schedule/edit', data, errorback);
  },
  /**
   * 删除技师排班
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  del(data, errorback) {
    return request._post('/supplier/technician.schedule/delete', data, errorback);
  },
  /**
   * 获取技师排班详情
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  detail(data, errorback) {
    return request._post('/supplier/technician.schedule/detail', data, errorback);
  },
  /**
   * 获取技师排班列表按照技师id
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getScheduleByTechnicianId(data, errorback) {
    return request._post('/supplier/technician.schedule/getScheduleByTechnicianId', data, errorback);
  },
  /**
   * 获取技师一周排班
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  getWeekSchedule(data, errorback) {
    return request._post('/supplier/technician.schedule/getWeekSchedule', data, errorback);
  },
  /**
   * 批量设置技师排班
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  batchSet(data, errorback) {
    return request._post('/supplier/technician.schedule/batchSet', data, errorback);
  },
  /**
   * 启用/禁用技师排班
   * @param {Object} data - 请求参数
   * @param {Function} errorback - 错误回调
   * @returns {Promise}
   */
  toggleActive(data, errorback) {
    return request._post('/supplier/technician.schedule/toggleActive', data, errorback);
  }
}

export default ScheduleApi;



// WEBPACK FOOTER //
// ./src/api/technician/schedule.js